module.exports = __webpack_public_path__ + "img/hero-iot.6d363525.jpg";